import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SUBMIT_BUTTON: `${cleanedFilename(__filename)}-submit`,
};
